const SELECT_DISCUSSION = (state, payload) => {
  state.selectedDiscussion = payload.discussionById;
  state.discussionRepliesLoadedAll = false;
  state.referenceData.discussionReportReasonTypes =
    payload.discussionReportReasons;
};

export default SELECT_DISCUSSION;
